import React, { FC } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import IBaseCheckbox from "./types";
import styles from "./BaseCheckbox.styled";

const BaseCheckbox: FC<IBaseCheckbox> = ({ label, onChange, checked }) => {
  return (
    <FormGroup sx={styles.checkboxWrap}>
      <FormControlLabel
        control={
          <Checkbox
            sx={styles.checkbox}
            onChange={onChange}
            checked={checked}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};

export default BaseCheckbox;
